export const bigPictureEventName = 'vimeo.eppo_feature_flag_assignment';
export const bigPictureEventSchemaVersion = 1;
